import React, { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {
  getAreaSelect,
  getAreaZoneSelect,
  getAreaDetailSelect,
  getEquipmentSelect,
  saveItem,
} from "./../../services/fire";
import Select from "../common/selectcustom";
import dlv from "dlv";
import { useForm } from "react-hook-form";
import moment from "moment";

import { FormInput } from "../common/forminput";
import Input from "../common/inputfunction";

import FontAwesome from "react-fontawesome";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";

const Additem = ({
  button1,
  isOpen,
  header,
  onCancel,
  onconfirm,
  value,
  list,
  dateday,
  selected,
  edit=false,
}) => {
 const [editname , seteditname] = useState('');
//  const [editdetail , seteditdetail] = useState('');

  let status;
  try {
    const ojb1 = value;
    status = dlv(ojb1, "status", true);
  } catch {}
  let editid;
  let name;
  let id;
  let areaname;
  let gareaid;
  let groupid;
  let groupname;
  let installdate;
  let detail;
  let areaDetail;
  try {
    const ojb = list[0];
    // console.log(ojb);
    editid = dlv(ojb, "_id", "0");
    name = dlv(ojb, "name", "");
    gareaid = dlv(ojb, "areaid", "0");
    areaname = dlv(ojb, "zoneid", "0");
    groupid = dlv(ojb, "groupid", "0");
    groupname = dlv(ojb, "groupname", "");
    installdate = dlv(ojb, "installdate2", new Date());
    detail = dlv(ojb, "detail", "");
    areaDetail = dlv(ojb, "detailid", "0");

  } catch {}
  const PreloadedValues = {
    id: editid,
    item: name,
    detail: detail,
  };
  //console.log("detail",detail)
  //console.log("date",list)
  if (installdate == null) {
    installdate = new Date();
  }
  const [error, seterror] = useState("");
  const [errorin , seterrorin] = useState({
    item:"",
    detail:""
  })

  const [autoid, setautoid] = useState(0);

  const [disable, setdisable] = useState(false);
  const [areaid, setareaid] = useState(0);
  const [areazone, setareazone] = useState(0);
  const [areadetail, setareadetail] = useState(0);
  const [equipmentid, setequipmentid] = useState(0);
  const [locationlist, setlocationlist] = useState([]);
  const [locationArealist, setLocationArealist] = useState([]);
  const [areadetailList, setareadetailList] = useState([]);
  const [equipmentlist, setequipmentlist] = useState([]);
  const [enabled, setenabled] = useState(true);
 const [remark ,setremark] = useState('');
  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm({
    mode: "onSubmit",
    //  defaultValues: PreloadedValues,
  });
  const [startDate, setStartDate] = useState(new Date());
  const [messageErros, setmessageErros] = useState({
    askAlert: { enable: false, message: "" },
  });

  const onChangeDate = (event) => {
    // console.log(event);
    setStartDate(event);
    //onChange(event);
  };

  // if (installdate) {
  //   setStartDate(queuedate);
  // } else {
  //   //   console.log(recorddate);
  // }
  useEffect(() => {
    isOpen ? setremark("") : setremark(detail);
    seterrorin({item:"",detail:""})
    seteditname("")
    seterror('')
  },[isOpen])
  useEffect(() => {
    if(isOpen === true){
      if (list.length > 0) {
      // console.log(list);
      setareaid(gareaid);
      setareazone(areaname)
      setareadetail(areaDetail)
      setequipmentid(groupid);
      setautoid(editid);
      setremark(detail)
      seteditname(name)
      const installdatea = new Date(installdate);
      setStartDate(installdatea);
      //console.log(id)
    } else {
      setareaid(0);
      setareazone(0);
      setareadetail(0);
      setequipmentid(0);
      setautoid(0);
      seterror("");
    }
    }else{

    }
    
  }, [setValue, list,isOpen]);

  useEffect(() => {
    setdisable(!status);
  }, [status]);

  useEffect(() => {
    const loadData = async () => {
      const { data: result } = await getAreaSelect();
      // console.log(result);
      if (result.status === "success") {
        setlocationlist(result.data.list);
      }
    };
    loadData();
    // console.log(edit);
  }, []);

  useEffect(() => {
    const loadData = async () => {
      const { data: result } = await getAreaZoneSelect(areaid||0);
      // console.log(result);
      if (result.status === "success") {
        setLocationArealist(result.data.list);
      }
    };
    loadData();
  }, [areaid]);

  useEffect(() => {
    const loadData = async () => {
      const { data: result } = await getAreaDetailSelect(areazone||0);
      // console.log(result);
      if (result.status === "success") {
        setareadetailList(result.data.list);
      }
    };
    loadData();
  }, [areazone]);

  useEffect(() => {
    const loadData = async () => {
      // const { data: result } = await getAreaDetailSelect();
      // console.log(result);
      // if (result.status === "success") {
      //   setareadetailList(result.data.list);
      // }
    };
    loadData();
  }, []);
  useEffect(() => {
    const loadData = async () => {
      const { data: result } = await getEquipmentSelect();
      if (result.status === "success") {
        setequipmentlist(result.data.list);
        // setvForm(true);
      }
    };
    loadData();
  }, []);
  const handleAreaChange = (event) => {
    setareaid(event.currentTarget.value);
    if (event.currentTarget.value !== 0) {
      seterror("");

    }
  };
  const handleAreaZoneChange = (event) => {
    setareazone(event.currentTarget.value);
    if (event.currentTarget.value !== 0) {
      seterror("");
    }
  };
  const handleareadetailChange = (event) => {
    setareadetail(event.currentTarget.value);
    if (event.currentTarget.value !== 0) {
      seterror("");
    }
  };

  const handleEquipChange = (event) => {
    setequipmentid(event.currentTarget.value);
    if (event.currentTarget.value !== 0) {
      seterror("");
    }
  };
  const onSubmit = (data) => {
    // console.log(data);
    seterror("");
    if (areaid === 0) {
      seterror("กรุณาระบุ พื้นที่");
      return;
    } else if (equipmentid === 0) {
      seterror("กรุณาระบุ ประเภทอุปกรณ์");
      return;
    } else if (areazone === 0) {
      seterror("กรุณาระบุ โซนติดตั้ง");
      return;
    } else if (areadetail === 0) {
      seterror("กรุณาระบุ จุดติดตั้ง");
     return;
    } else if (!editname || editname.length === 0){
      seterrorin({item:"กรุณาระบุรหัสอุปกรณ์",detail:""})
      return;
    } else if(editname.length>50){
      seterrorin({item:"Max length is 50",detail:""})
      return;
    } else if(editname.length<2){
      seterrorin({item:"ระบุอย่างน้อย 2 ตัวอักษร",detail:""})
      return;
    }
    
  

    const saveobject = {
      id: autoid,
      areid: areaid,
      groupid: equipmentid,
      disable: disable,
      Install_date: moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
      detail: remark,
      areazone: areazone,
      areadetail: areadetail,
      item: editname,
      isEdit: edit,
      ...data,
    };
    SaveData(saveobject);
  };

  // const sss =() =>{
  //    console.log(areazone,areadetail);
  // }
  const SaveData = async (doc) => {
    // console.log( doc);
    // console.log(edit);
    try {
      const { data: result } = await saveItem(doc);
      // console.log(result);
      if (result.status === "success") {
        toast.success("บันทึกเสร็จเรียบร้อย");
        onconfirm();
      } else {
        toast.error(result.message);
        seterror(result.message);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const handleTextchange = () => {
    setdisable(!disable);
  };

  const handleeditname =(data)=>{
    // console.log(data);
    seteditname(data);
    seterrorin({item:"" , detail:""})
  }
  const handleeditdetail =(data)=>{
    // console.log(data);
    setremark(data);
    seterrorin({item:"" , detail:""})
  }
  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <div>
        <Modal
          isOpen={isOpen}
          toggle={onCancel}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <ModalHeader>
            <FontAwesome name="pencil-square-o"> </FontAwesome> {header}
          </ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-sm-4 col-xs-12">
                <div className="form-group">
                  {/* <Select
                    label="วันที่ติดตั้งอุปกรณ์"
                    data={equipmentlist}
                    value={equipmentid}
                    textProperty="name"
                    valueProperty="_id"
                    onChange={handleEquipChange}
                  /> */}
                  <div className="col">วันที่ติดตั้งอุปกรณ์</div>

                  <DatePicker
                    label="วันที่ติดตั้งอุปกรณ์"
                    todayButton="Today"
                    dateFormat="dd/MM/yyyy"
                    selected={startDate}
                    onChange={onChangeDate}
                  />
                </div>
              </div>
              <div className="col-sm-4 col-xs-12">
                <div className="form-group">
                  {/* {console.log(editname)} */}

                  <Input
                    id="item"
                    name="item"
                    type="text"
                    value={editname}
                    label="รหัสอุปกรณ์"
                    placeholder={"รหัส QR Code"}
                    onChange = {(e) => handleeditname(e.target.value)}
                    // defaultValue={PreloadedValues.item}
                    // register={register("item", {
                    //   required: "กรุณาระบุรหัสอุปกรณ์",
                    //   maxLength: {
                    //     value: 1000,
                    //     message: "Max length is 50",
                    //   },
                    //   minLength: {
                    //     value: 2,
                    //     message: "ระบุอย่างน้อย 2 ตัวอักษร",
                    //   },
                    // })}
                    // error={errors.item}
                    error={errorin.item}

                  />
                </div>
              </div>
              <div className="col-sm-4 col-xs-12">
                <div className="form-group">
                  <Select
                    label="ประเภทอุปกรณ์"
                    data={equipmentlist}
                    value={equipmentid}
                    textProperty="name"
                    valueProperty="_id"
                    onChange={handleEquipChange}
                  />
                </div>
              </div>
              <div className="col-sm-4 col-xs-12">
                <div className="form-group">
                  <Select
                    label="พื้นที่ (Location)"
                    data={locationlist}
                    value={areaid}
                    textProperty="name"
                    valueProperty="_id"
                    onChange={handleAreaChange}
                  />
                </div>
              </div>
              <div className="col-sm-4 col-xs-12">
                <div className="form-group">
                  <Select
                    label="พื้นที่โซน (Area)"
                    data={locationArealist}
                    value={areazone}
                    textProperty="name"
                    valueProperty="_id"
                    onChange={handleAreaZoneChange}
                  />
                </div>
              </div>
              {/* {console.log(areaid,areazone,areadetail)} */}
              <div className="col-sm-4 col-xs-12">
                <div className="form-group">
                  <Select
                    label="จุดติดตั้ง (Area Detial)"
                    data={areadetailList}
                    value={areadetail}
                    textProperty="name"
                    valueProperty="_id"
                    onChange={handleareadetailChange}
                  />
                </div>
              </div>
              <div className="col-sm-6 col-xs-12">
                <div className="form-group">
                  <Input
                    id="detail"
                    name="detail"
                    type="text"
                    label="รายละเอียดการติดตั้ง"
                    value={remark}
                    onChange={(e)=>{handleeditdetail(e.target.value)}}
                    placeholder={ "กรุณาระบุรายละเอียดการติดตั้ง"}
                    // defaultValue={remark}
                    // register={register("detail", {
                    //   required: "กรุณาระบุรายละเอียดการติดตั้ง",
                    //   maxLength: {
                    //     value: 1000,
                    //     message: "Max length is 5",
                    //   },
                    //   minLength: {
                    //     value: 2,
                    //     message: "ระบุอย่างน้อย 2 ตัวอักษร",
                    //   },
                    // })}
                    // error={errorin.detail}
                  />
                </div>
              </div>
              {edit ? (
                <div className="col-sm-2 col-4 text-start">
                  <Input
                    name="disable"
                    value={disable}
                    label="ยกเลิกใช้งาน"
                    type="checkbox"
                    onChange={handleTextchange}
                    checked={disable}
                    error=""
                  />
                </div>
              ) : null}
            </div>
          </ModalBody>
          {error && (
            <div className="col-md-12 alert alert-danger"> {error}</div>
          )}

          {list && list.comment && (
            <Button color="danger">{list.comment}</Button>
          )}
          <ModalFooter>
            {enabled && (
              <Button color="primary" onClick={handleSubmit(onSubmit)}>
                {button1}
              </Button>
            )}

            <Button color="secondary" onClick={onCancel}>
              ยกเลิก
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </form>
  );
};

export default Additem;
